import { Head } from '@inertiajs/react';

export function GoogleFontLinks({ url }: { url: string | null }) {
  if (!url) return null;

  return (
    <Head>
      <link
        head-key="google-fonts-static-preconnect"
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link head-key={`google-fonts-stylesheet-${url}`} href={url} rel="stylesheet" />
    </Head>
  );
}
